import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {Router} from '@angular/router';
import {Location} from '@angular/common';
import {TaskDTO, UserDTO} from '@tj/tj-dmp-lib-api';

@Injectable({providedIn: 'root'})
export class DmpWebsocketService {
    private ws: WebSocket;
    private alreadyConnectedOnce = false;

    public connected = new BehaviorSubject<boolean>(false);
    /** updateTask */
    public listenerUpdateTaskObserver: Subject<string> = new Subject<string>();
    /** updateDataTask */
    public listenerUpdateDataTaskObserver: Subject<TaskDTO> = new Subject<TaskDTO>();

    constructor(
        private router: Router,
        private location: Location
    ) {
    }

    connect(user: UserDTO) {
        if (this.alreadyConnectedOnce) {
            console.log('this.alreadyConnectedOnce: ' + this.alreadyConnectedOnce);
            return;
        }
        if (this.ws !== null) {
            console.log('this.ws is not null');
            this.disconnect();
        }
        // building absolute path so that websocket doesn't fail when deploying with a context path
        // set ws protocol when using http and wss when using https
        const protocol = window.location.protocol.replace('http', 'ws');
        // get location host
        const host = window.location.host;
        // let url = '/websocket/tracker';
        let url = '/ws/messages';
        url = this.location.prepareExternalUrl(url);
        const authToken = user.login;
        if (authToken) {
            url += '/' + authToken;
            // url += '?access_token=' + authToken;
        }

        // websocket instantiation
        this.ws = new WebSocket(`${protocol}//${host}${url}`);
        // this.ws = new WebSocket(`ws://localhost:8080${url}`);
        this.ws.onopen = () => {
            this.connected.next(true);
            this.alreadyConnectedOnce = true;
            this.sendHello();
            console.log('Info: Connection Established.');
        };

        this.ws.onmessage = (event) => {
            console.log(event.data);
            /*const msg = JSON.parse(event.data) as MessageWs;
            switch (msg.destination) {
                case 'update-task':
                    this.listenerUpdateTaskObserver.next(msg.body as string);
                    break;
                case 'task':
                    this.listenerUpdateDataTaskObserver.next(msg.body as TaskDTO);
                case 'ping':
                    console.log('ping');
                default:
                    break;
            }*/
        };

        this.ws.onclose = (event) => {
            console.log('Info: Closing Connection.');
            console.log(event);
        };
    }

    disconnect() {
        if (this.ws != null) {
            this.ws.close();
            this.ws = null;
        }
        this.connected.next(false);
        this.alreadyConnectedOnce = false;
    }

    sendHello() {
        if (this.ws) {
            this.sendMessage({
                messageString: 'hello'
            });
        }
    }
    sendMessage(msg: any) {
        if (this.ws) {
            this.ws.send(JSON.stringify(msg));
        }
    }
}


export interface MessageWs {
    destination: string;
    body?: any;
    header?: any;
}
